import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const NetworkMonitoring = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5 16C13.5 15.1716 12.8284 14.5 12 14.5C11.1716 14.5 10.5 15.1716 10.5 16V16.25C10.5 17.2165 9.7165 18 8.75 18H7C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18H15.25C14.2835 18 13.5 17.2165 13.5 16.25V16Z"
            fill="url(#paint0_linear_123_17427)"
          />
          <path
            d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H6C4.89543 16 4 15.1046 4 14V6Z"
            fill="url(#paint1_linear_123_17427)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.2572 8.33576L10.5115 10.0756C10.4012 10.333 10.1481 10.4999 9.86812 10.4999H7C6.72386 10.4999 6.5 10.276 6.5 9.9999C6.5 9.72376 6.72386 9.4999 7 9.4999H9.6703L10.7595 6.9585C11.0382 6.30811 11.9958 6.43475 12.0958 7.13525L12.7428 11.664L13.4885 9.92416C13.5988 9.66678 13.8519 9.4999 14.1319 9.4999H17C17.2761 9.4999 17.5 9.72376 17.5 9.9999C17.5 10.276 17.2761 10.4999 17 10.4999H14.3297L13.2405 13.0413C12.9618 13.6917 12.0042 13.5651 11.9042 12.8646L11.2572 8.33576Z"
            fill="#0F144C"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_17427"
              x1="10"
              y1="20"
              x2="10"
              y2="17.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#868BFF" />
              <stop offset="1" stop-color="#69EDF1" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_17427"
              x1="8.5"
              y1="16"
              x2="8.5"
              y2="4"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#868BFF" />
              <stop offset="1" stop-color="#69EDF1" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default NetworkMonitoring;
